import { isRecord } from '@atlassian/conversation-assistant-utils/isRecord';

type MessageActionErrorAttributes = {
	conversationId: string;
	messageId: string;
	invocationId: string;
	actionKey: string;
	statusCode?: number;
	errorCode?: string;
	rawErrorMessage?: string;
	traceId?: string;
	requestId?: string;
};

interface RovoMessageActionError extends Error {
	errorAttributes: MessageActionErrorAttributes;
}

const getCauseErrorAttributes = (cause?: Error): Partial<MessageActionErrorAttributes> => {
	if (!cause || !('errorAttributes' in cause) || !isRecord(cause.errorAttributes)) {
		return {};
	}

	const { statusCode, errorCode, rawErrorMessage, traceId, requestId } = cause.errorAttributes;

	return {
		...(typeof statusCode === 'number' ? { statusCode } : {}),
		...(typeof errorCode === 'string' ? { errorCode } : {}),
		...(typeof rawErrorMessage === 'string' ? { rawErrorMessage } : {}),
		...(typeof traceId === 'string' ? { traceId } : {}),
		...(typeof requestId === 'string' ? { requestId } : {}),
	};
};

export class MessageActionError extends Error implements RovoMessageActionError {
	errorAttributes: RovoMessageActionError['errorAttributes'];
	cause?: Error;

	constructor(params: {
		message: string;
		conversationId: string;
		messageId: string;
		invocationId: string;
		actionKey: string;
		cause?: Error;
	}) {
		super(params.message);
		this.name = this.constructor.name;
		this.errorAttributes = {
			conversationId: params.conversationId,
			messageId: params.messageId,
			invocationId: params.invocationId,
			actionKey: params.actionKey,
			...getCauseErrorAttributes(params.cause),
		};
		if (params.cause) {
			this.cause = params.cause;
		}
	}
}
